import { useEffect, useMemo, useState } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import useAuthAccess from "../../hooks/useAuthAccess";
import { getProfileImages } from "../../utils/profileLookup";
import { db } from "../../firebase";

export default function useSettingsProfile() {
  const navigate = useNavigate();
  const { user, profile, loading } = useAuthAccess();
  const [error, setError] = useState("");

  useEffect(() => {
    if (!loading && !user) {
      navigate("/login");
    }
  }, [loading, user, navigate]);

  const settingsProfile = useMemo(() => {
    if (!profile) return null;
    return {
      ...profile,
      imageUrls: getProfileImages(profile),
    };
  }, [profile]);

  const [liveProfile, setLiveProfile] = useState(settingsProfile);

  useEffect(() => {
    setLiveProfile(settingsProfile);
  }, [settingsProfile]);

  useEffect(() => {
    if (!settingsProfile?.id) return undefined;

    const profileRef = doc(db, "profiles", settingsProfile.id);
    const unsubscribe = onSnapshot(
      profileRef,
      (snapshot) => {
        if (!snapshot.exists()) {
          setLiveProfile(null);
          return;
        }

        const nextProfile = { id: snapshot.id, ...snapshot.data() };
        setLiveProfile({
          ...nextProfile,
          imageUrls: getProfileImages(nextProfile),
        });
      },
      () => {
        // Keep the current in-memory profile if the live listener fails.
      }
    );

    return unsubscribe;
  }, [settingsProfile?.id]);

  return {
    user,
    profile: liveProfile,
    profileId: liveProfile?.id || null,
    loading,
    error,
    setError,
  };
}
